import { PageLayout, TertiaryBar } from '@kcftech/design-system';
import {
    ICorporationResponse,
    ILocationResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { NavTabLink } from 'components/tabs/NavTabs';
import { TabRouter } from 'components/tabs/TabRouter';
import { usePermissions } from 'contexts/PermissionsContext';
import { useRouteTabs } from 'custom_hooks/data_hooks/data_source/useRouteTabs';
import { GroupViewTab } from 'pages/Settings/NotificationSubscriptions/GroupViewTab';
import { UserViewTab } from 'pages/Settings/NotificationSubscriptions/UserViewTab';
import { useMemo } from 'react';
import { ContextualPageProps } from 'utils/types';

const getTabs = (
    canViewGroupNotificationSubscriptions: boolean,
    corporation?: ICorporationResponse,
    location?: ILocationResponse
) =>
    !canViewGroupNotificationSubscriptions
        ? [
              {
                  id: 'userView',
                  label: 'User View',
                  content: <UserViewTab corporation={corporation} location={location} />,
              },
          ]
        : [
              {
                  id: 'userView',
                  label: 'User View',
                  content: <UserViewTab corporation={corporation} location={location} />,
              },
              {
                  id: 'groupView',
                  label: 'Group View',
                  content: <GroupViewTab corporation={corporation} location={location} />,
              },
          ];

export function NotificationSubscriptionsPage({
    corporation,
    location,
}: ContextualPageProps) {
    const { canViewGroupNotificationSubscriptions } = usePermissions();
    const { routeTabs } = useRouteTabs(
        useMemo(
            () => getTabs(canViewGroupNotificationSubscriptions, corporation, location),
            [canViewGroupNotificationSubscriptions, corporation, location]
        )
    );

    return (
        <>
            <PageLayout.Tertiary className="scrollable-x">
                <TertiaryBar.Navigation>
                    <TertiaryBar.Items>
                        <TertiaryBar.Item>
                            {routeTabs.map(({ id, url, label }) => (
                                <NavTabLink key={id} to={url} className="p-10">
                                    {label}
                                </NavTabLink>
                            ))}
                        </TertiaryBar.Item>
                    </TertiaryBar.Items>
                </TertiaryBar.Navigation>
            </PageLayout.Tertiary>
            <TabRouter routeTabs={routeTabs} />
        </>
    );
}
